export const OK_STATUS = 200
export const ILLEGAL_STATUS = 1300
export const DUPLICATED_BINDING_CARD = 10002
export const PAYMENT_COMPLETED = 101
